export {LayoutSwitcherComponent} from './layout-switcher.component';
export {LayoutService} from './layout.service';
export {SmartadminLayoutModule} from './layout.module';




